import { theme } from '@shared/theme/theme';

const { colors } = theme;

/**
 * Shared look for all floating surfaces hanging off the app chrome
 * (sidebar label/group popovers, account menu): white card, soft border,
 * 12px radius. Spread into the paper `sx` of a Popover/Menu.
 */
export const popoverPaperSx = {
  borderRadius: '12px',
  backgroundColor: colors.white,
  color: colors.highText,
  border: `1px solid ${colors.divider}`,
} as const;
